module.exports = __webpack_public_path__ + "static/img/cart2.1d43d7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cart2.png
// module id = Iwnx
// module chunks = 2